module.exports = __webpack_public_path__ + "img/5.8380c774.png";